import React from 'react';

const SvgFullscreen2 = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
		<path d="M29.52 14c-.27 0-.52.11-.71.29-.19.19-.29.44-.29.71s.11.52.29.71.44.29.71.29h1.08L27 19.61c-.15.19-.22.44-.21.68.02.24.12.48.3.65a1.01 1.01 0 0 0 1.33.06L32 17.42v1.06c0 .27.11.52.29.71s.44.29.71.29.52-.11.71-.29.29-.44.29-.71v-4a.47.47 0 0 0-.15-.35.5.5 0 0 0-.35-.15zM18.48 34c.27 0 .52-.11.71-.29.19-.19.29-.44.29-.71s-.11-.52-.29-.71-.44-.29-.71-.29H17.4l3.6-3.61c.15-.19.22-.44.21-.68-.02-.24-.12-.48-.3-.65a1.01 1.01 0 0 0-1.33-.06L16 30.58v-1.06c0-.27-.11-.52-.29-.71s-.44-.29-.71-.29-.52.11-.71.29-.29.44-.29.71v4c0 .13.05.26.15.35.09.09.22.15.35.15z" />
	</svg>
);
export default SvgFullscreen2;
